import { SubmitShoppingCartResponse } from 'app/api/@generated/backend';

import { ShoppingCartService } from 'app/pages/order/services/shopping-cart-service';
import {
    selectIsExtraUnitNeeded,
    selectIsPurchasingSingleUnit,
    selectPartner,
    selectSelectedAccountOrThrow,
    selectSelectedAmountOfUnitsToPurchase,
    selectSelectedHouseType,
    selectSelectedServiceLocationOrThrow,
    selectSelectedUserDetailsOrThrow,
    selectShoppingCartOrThrow,
} from 'app/pages/order/redux/order-selector';
import { createAppAsyncThunk } from 'app/redux/utils/thunk-utils';
import { RequestType } from 'app/pages/order/redux/model/order-request';
import { pushPurchaseEvent } from 'app/data-layers/events/push-purchase-event';

export const submitShoppingCartActionCreator = createAppAsyncThunk<SubmitShoppingCartResponse>(
    'order/submitShoppingCart',
    async (_, { getState }) => {
        const rootState = getState();
        const partner = selectPartner(rootState);
        const shoppingCart = selectShoppingCartOrThrow(rootState);
        const serviceLocation = selectSelectedServiceLocationOrThrow(rootState);
        const userDetails = selectSelectedUserDetailsOrThrow(rootState);
        const numberOfUnitsToAdd = selectSelectedAmountOfUnitsToPurchase(rootState);
        const isPurchasingSingleUnit = selectIsPurchasingSingleUnit(rootState);
        const isPurchasingExtraUnit = selectIsExtraUnitNeeded(rootState);
        const selectedHouseType = selectSelectedHouseType(rootState);
        const { partnerId } = selectSelectedAccountOrThrow(rootState);
        const { id: shoppingCartId } = shoppingCart;

        const submitShoppingCart = await ShoppingCartService.submitShoppingCart(
            partnerId,
            shoppingCartId,
            numberOfUnitsToAdd,
            serviceLocation,
            userDetails,
        );

        pushPurchaseEvent(
            shoppingCart,
            selectedHouseType,
            isPurchasingExtraUnit,
            numberOfUnitsToAdd,
            isPurchasingSingleUnit,
            submitShoppingCart.orderNumber,
            partner,
        );

        return submitShoppingCart;
    },
    {
        getPendingMeta: () => ({ requestType: RequestType.SUBMIT_SHOPPING_CART }),
    },
);
